var app = angular.module('leonardo');

var GenderFilter = function (AccountUserService) {
  return function (gender) {
    var label = '';
    angular.forEach(AccountUserService.GENDER_OPTIONS, function(option) {
      if (option.id == gender) label = option.name;
    });
    return label;
  }
};

app.filter('gender', ['AccountUserService', GenderFilter]);
